import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.5 2.5H4.5a2 2 0 00-2 2v15a2 2 0 002 2h15a2 2 0 002-2V4.5a2 2 0 00-2-2z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.656 13.9l6.95-6.95 1.414 1.414-7.657 7.657H9.95l-3.657-3.657 1.415-1.414 2.95 2.95z", fill: "currentColor", stroke: "transparent" })));
export default createSvgIcon(iconPath, "CheckboxChecked");
//# sourceMappingURL=CheckboxCheckedIcon.js.map